import React from "react";
import { APP_COLORS, APP_NAME } from "config/branding";

/**
 * Panel derecho del layout de auth: imagen (Unsplash) + velado con colores de marca.
 * Sin assets locales del template Horizon.
 */
const HERO_IMAGE =
  "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1920&q=80";

export default function AuthMarketingAside() {
  return (
    <div className="absolute right-0 top-0 hidden h-full min-h-screen md:block lg:w-[49vw] 2xl:w-[44vw]">
      <div className="relative h-full min-h-screen overflow-hidden lg:rounded-bl-[120px] xl:rounded-bl-[200px]">
        <div
          className="absolute inset-0 scale-105 bg-cover bg-center transition-transform duration-700 ease-out"
          style={{ backgroundImage: `url(${HERO_IMAGE})` }}
          aria-hidden
        />
        <div
          className="absolute inset-0"
          style={{
            background: `linear-gradient(145deg, ${APP_COLORS.primary}e6 0%, ${APP_COLORS.primary}b3 45%, ${APP_COLORS.tertiary}99 100%)`,
          }}
          aria-hidden
        />
        <div
          className="absolute inset-0 opacity-[0.12]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.9) 1px, transparent 0)",
            backgroundSize: "28px 28px",
          }}
          aria-hidden
        />
        <div className="relative z-10 flex h-full min-h-screen flex-col justify-end px-8 pb-14 pt-24 md:px-10 xl:px-14 xl:pb-20">
          <div className="max-w-lg">
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-white/75">
              Facturación electrónica Chile
            </p>
            <h2 className="mb-4 font-poppins text-3xl font-bold leading-[1.15] tracking-tight text-white sm:text-4xl xl:text-[2.75rem]">
              {APP_NAME}
            </h2>
            <p className="text-sm leading-relaxed text-white/90 sm:text-base">
              Operá DTE emitidos, compras, CAF y ambientes SII con una interfaz
              pensada para equipos que necesitan claridad entre certificación y
              producción.
            </p>
          </div>
          <p className="mt-10 text-[11px] text-white/35">
            Imagen vía{" "}
            <a
              href="https://unsplash.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-white/30 underline-offset-2 hover:text-white/55"
            >
              Unsplash
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
